//  ----------      START   IMPORT  BLOCK       ----------
import { useState, useEffect, useRef, useCallback } from 'react';
//  REACT Bootstrap.
import { Button, ButtonGroup } from 'react-bootstrap';
import { FaQuestionCircle } from 'react-icons/fa';
import { Form } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Accordion from 'react-bootstrap/Accordion';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
//  Models
import Prescription from '../../Models/Prescription';
import Instruction from '../../Models/Instruction';
import Diagnosis from '../../Models/Diagnosis';
//  Components.
import ListBox2 from '../SearchBox/listBox2';
import Exploration from './exploration';
import Interrogation from './interrogation';
import LaboratoryTests from './laboratory_tests';
import DiagnosisTextBox from '../Widgets/Professional/DiagnosisTextEditor/DiagnosisTextBox';
import PrescriptionTextBox from '../Widgets/Professional/PrescriptionTextEditor/PrescriptionTextBox.jsx';
//  Modals.
import DiagnosisInstructions from './InstructionsModals/diagnosis_instructions';
import PrescriptionInstructions from './InstructionsModals/prescription_instructions';
import MissingInfoModal from './MissingInfoModal/MissingInfoModal';
//  Context.
import { useLanguage } from '../../API/Context/LanguageContext'
//import { useUserDiagnoses } from '../../API/Hooks/useUserDiagnoses';
import { useDiagnosis } from '../../API/Hooks/useDiagnosis';
import { useActivePatient } from '../../API/Hooks/ActivePatientContext';
//  Services
import AutocompleteCieService from '../../API/Services/AutoCompleteCieService';
import AutocompleteDrugService from '../../API/Services/AutocompleteDrugService';
//  Config
import API_ROUTES from '../../ConfigFiles/Routes/api_routes';
import { VocabDiagnosis as vocab} from '../../ConfigFiles/multilingual/VocabDiagnosis';
import {VocabButtons as btn_vocab} from '../../ConfigFiles/multilingual/VocabButtons';
import colorVitalSigns from '../../ConfigFiles/colors/color_vital_signs';
//  ----------      END   IMPORT  BLOCK       ----------


const DiagnosisForm = ({ }) => {
  //  Consume context.
  const { lan } = useLanguage()
  //const { createDiagnosisEntry } = useUserDiagnoses()
  const { submitDiagnosis, isLoading } = useDiagnosis();
  const { activePatient } = useActivePatient();
  //  Services
  const autocompleteCieService = new AutocompleteCieService();
  const dataPromiseConditions = (query, signal) => autocompleteCieService.searchConditions(query, signal);
  const autocompleteDrugService = new AutocompleteDrugService();
  const dataPromiseDrugs = (query, signal) => autocompleteDrugService.searchDrugs(query, signal);
  //  State used for save button.
  const [enableSaveEntry, setEnableSaveEntry] = useState(true);
  //  Ref for the diagnosis Quill component.
  const quillRef = useRef(null);
  //  Ref for prescription text.
  const prescriptionTextRef = useRef('');

  console.log('API_ROUTES.search_conditions(query), , API_ROUTES.search_conditions(query)', API_ROUTES.search_conditions('hi'))

  const interrogationTextRef = useRef('');
  const [interrogationCompleted, setInterrogationCompleted] = useState(false);

  const explorationTextRef = useRef('');
  const [explorationCompleted, setExplorationCompleted] = useState(false);
  const laboratoryTextRef = useRef('');
  const [laboratoryCompleted, setLaboratoryCompleted] = useState(false);

  const [activeIndex, setActiveIndex] = useState(null);
  const activeIndexRef = useRef(activeIndex);

  const diagnosisText = useRef('');
  const diagnosisTags = useRef([]);

  /*    Help/Instructions modals   */
  //  Diagnosis.
  const [showDiagnosisModal, setDiagnosisModal] = useState(false);
  const handleDiagnosisModal = () => setDiagnosisModal(true);
  const handleCloseDiagnosisModal = () => setDiagnosisModal(false);
  //  Prescription.
  const [showPrescriptionModal, setShowPrescriptionModal] = useState(false);
  const handlePrescriptionModal = () => setShowPrescriptionModal(true);
  const handleClosePrescriptionModal = () => setShowPrescriptionModal(false);
  //  Missing Info.
  const [showMissingInfoModal, setMissingInfoModal] = useState(false);
  const handleShowMissingInfoModal = () => setMissingInfoModal(true);
  const handleCloseMissingInfoModal = () => setMissingInfoModal(false);


  const handleTextChangeDiagnosis = (text) => {
    diagnosisText.current = text
  };

  const handleDiagnosisTags = (tags) => {
    diagnosisTags.current = tags
  };

  const handleTextChangePrescription = (text) => {
    prescriptionTextRef.current = text
  };

  const handleTextChangeInterrogation = useCallback((text) => {
    interrogationTextRef.current = text
    setInterrogationCompleted(text.trim() !== '')
  }, []);

  const handleTextChangeExploration = useCallback((text) => {
    explorationTextRef.current = text
    setExplorationCompleted(text.trim() !== '')
  }, []);

  const handleTextChangeLaboratory = useCallback((text) => {
    laboratoryTextRef.current = text
    setLaboratoryCompleted(text.trim() !== '')
  }, []);

  const digestPrescriptionText = () => {
    const raw_text = prescriptionTextRef.current
    let delimiters = identifyInstructionsBlocks(raw_text)
    if (!delimiters.length) {
      console.log('No instructions are being redacted.')
      return;
    }
    const separated_instructions = separate_instructions(raw_text, delimiters);
    let digested_instructions = []

    for (let i = 0; i < Math.min(separated_instructions.length, delimiters.length); i++) {
      digested_instructions.push(extract_instruction_parts(delimiters[i][0], separated_instructions[i]))
    }
    return new Prescription(digested_instructions, raw_text)
  };

  const handleOptionsClick = (index) => {
    setActiveIndex(index);
  };


  const extract_instruction_parts = (instruction_number, instruction) => {

    let drug = '';
    let verb = '';

    let instruction_type = 0;

    let drug_number = 0.0;
    let drug_unit = 0;

    let periodicity_number = 0.0;
    let periodicity_unit = 0;

    let duration_number = 0.0;
    let duration_unit = 0;

    let indication_of_use = '';

    console.log('instructioninstructioninstructioninstruction', instruction)


    //  No instructions.
    if (!instruction.length) { return []; }

    //  Text before hyphen should be the drug.
    const drug_part = instruction.split('-');
    if (drug_part.length >= 1) {
      drug = drug_part[0]
    }
    if (drug_part.length > 2) {
      //  More than one hyphen.
      console.log('More than one hyphen.');
      return;
    }

    //  Retrieve instruction body.
    const instruction_raw_body = drug_part[1];
    //  Indication of use starts after semicolon if it exist avoid further processing.
    if (drug_part[1].indexOf(';') > 0) {
      //  Get text after semicolon.
      indication_of_use = instruction_raw_body.split(';')[1]
    }

    //  Process body.
    const number_count_digested_body = digest_instruction(instruction_raw_body)

    const processed_instruction = (() => {
      switch (number_count_digested_body[0]) {
        case 3:
          instruction_type = 3
          //  To track which float it is.
          let floatCount = 0;
          for (let i = 0; i < number_count_digested_body[1].length; i++) {
            let element = number_count_digested_body[1][i];
            //  Get the next element, or null if it's the last one
            let nextElement = i < number_count_digested_body[1].length - 1 ? number_count_digested_body[1][i + 1] : '';


            if (typeof element === 'number') {
              floatCount++;
              switch (floatCount) {
                case 1:
                  //  Fisrt number should be drug number and following string its unit.
                  drug_number = element
                  drug_unit = nextElement
                  break;
                case 2:
                  //  Second number should be peridicity number and following string its unit.
                  periodicity_number = element
                  periodicity_unit = nextElement
                case 3:
                  //  Third number should be duration number and following string its unit.
                  duration_number = element
                  duration_unit = nextElement
              }
            }
            //  String, no number and next elment is number means this is the verb.
            if (!floatCount && typeof nextElement === 'number' && typeof element === 'string') {
              verb = element
            }
          }
          return new Instruction(
            instruction_number,
            instruction_type,
            drug,
            instruction,
            verb,
            drug_number,
            drug_unit,
            periodicity_number,
            periodicity_unit,
            duration_number,
            duration_unit,
            indication_of_use);

        case 2:

          break;
        case 1:

          break;
        default:

          break;
      }
    })();
    return processed_instruction;

  }

  function fraction_to_float(numerator, denominator, whole = 0) {
    return parseFloat(whole) + (parseFloat(numerator) / parseFloat(denominator))
  }

  function digest_instruction(instruction_raw_body) {
    //  Split word for processing.
    let raw_body_splitted = instruction_raw_body.split(' ')
    //  Regex for words (u Unicode property escapes).
    const word_regex = /\p{L}+.?/u;
    //  Regex for integers.
    const integer_regex = /^\d+$/;
    //  Regex for fractional numbers (e.g. 1/2).
    const fraction_regex = /\d+\/\d+/;
    //  Regex for fractional numbers (e.g., 1 1/2).
    const whole_fractionRegex = /(\d+)\s+(\d+)\/(\d+)/;
    //  Regex for decimal numbers (e.g., 1.5).
    const decimalRegex = /\d+\.\d+/;

    //  To save processed text.
    let digested_body = [];
    let separated_body = [];
    //  Count of contained numbers
    let number_count = 0;

    // Detect decimal, fractionl and whole fractional numbers 1 1/2
    raw_body_splitted.forEach((part, index) => {
      //  Words are just passed.
      if (word_regex.test(part)) {
        digested_body.push(part);
        separated_body.push(part);
        return;
      };

      //  Lone fraction number.
      if (fraction_regex.test(part)) {
        if (integer_regex.test(raw_body_splitted[index + -1])) {
          //  Avoid duplicating fractional numbers.
          return;
        }

        const sliced_fraction = part.slice('/')
        digested_body.push(fraction_to_float(sliced_fraction[0], sliced_fraction[2]));
        separated_body.push(part);
        number_count += 1;
        return;
      }

      //  Decimal number.
      if (decimalRegex.test(part)) {
        digested_body.push(parseFloat(part));
        separated_body.push(part);
        number_count += 1;
        return;
      }

      //  Whole fractional number.
      //  Look for fractions, an extra position and see if it is fractional.
      if (integer_regex.test(part) && index !== instruction_raw_body.length - 1 && fraction_regex.test(raw_body_splitted[index + 1])) {
        //  Make one string out of it.
        const new_whole_fractional_number_str = [part, raw_body_splitted[index + 1]].join(' ');
        //  Create float
        const frational_part = raw_body_splitted[index + 1].slice('/');
        //  
        //  Whole + fraction = Integer + Numerator[0] Denominator[1].
        const new_whole_fractional_number_float = fraction_to_float(frational_part[0], frational_part[2], part);
        digested_body.push(new_whole_fractional_number_float);
        separated_body.push(`${part} ${frational_part[0]}/${frational_part[2]}`);
        //console.log('new_whole_fractional_number', new_whole_fractional_number_str, new_whole_fractional_number_float)
        number_count += 1;
        return;
      }

      //  Integer number.
      //  After whole + fraction skip to avoid confusing int with whole + fraction.
      if (integer_regex.test(part)) {
        digested_body.push(parseFloat(part))
        separated_body.push(part);
        number_count += 1;
      }
    });
    //  Quantity of numbers contained in text, text in a list form with numerical values as floats, text in a list form with numerical values merged.
    return [number_count, digested_body, separated_body]
  }

  const identifyInstructionsBlocks = (text) => {
    //  Keep track of delimiter positions
    const delimiters_positions = []
    //  Regex to match digit parenthesis
    const number_parentheses_regex = /^\d{1,2}\)$/;
    //  Break text into lines
    const lines = text.split('\n')
    //  Instruction must conformed by at least 2 lines.
    if (lines.length < 1) {
      return delimiters_positions;
    }
    //  Search for delimiter
    lines.forEach((line) => {
      //  Pass only lines conforming with regex
      if (number_parentheses_regex.test(line)) {
        //  Retrieve number duplicates.
        const position = text.indexOf(line)
        if (position.length > 1) {
          console.log(`instruction of index ${line} is being repeated.`)
        }
        //  Retrieve instruction number only.
        const instruction_number = line.split(')')[0]
        //  Save instruction with it's position.
        delimiters_positions.push([parseInt(instruction_number), position])
      }
    });
    //  Make positions accesible.
    return delimiters_positions;

  };

  const separate_instructions = (full_text, delimiters) => {
    //  No instructions.
    if (delimiters < 0) { return []; }
    //  One instruction.
    if (delimiters.length === 1) {
      //  Ignore number, parethesis & line break will result in extracted insturction.
      return [full_text.slice(delimiters[0][1] + delimiters[0][0].toString().length + 2).trim()];
    }
    //  1+ instructions.
    let extracted_instructions = []
    delimiters.forEach((instruction, index) => {

      //  Instruction isn't the last.
      if (index + 1 !== delimiters.length) {

        const next_instruction_start = delimiters[index + 1][1]
        //  Ignore number, parenthesis and linebreak, and add that to array extracted instruction.
        extracted_instructions.push(full_text.slice(instruction[1] + delimiters[0][0].toString().length + 2, next_instruction_start).trim())
        //  Skip to next iteration.
        return;
      }
      //  Ignore number, parenthesis and linebreak and add that to array extracted instruction.
      extracted_instructions.push(full_text.slice(+ delimiters[0][0].toString().length + 2 + instruction[1]).trim())
    });
    //  Return extracted instructions.
    return extracted_instructions;
  }

  const handleExtractCompleteEntry = () => {
    if (vitalsCompleted) {
      sendEntryToAPI();
    }
    handleShowMissingInfoModal();
  }
///*
  const sendEntryToAPI = async (entryToSave) => {
    // Guard clause to ensure an active patient is selected
  if (!activePatient?.patient) {
    console.error("Cannot submit diagnosis: No active patient selected.");
    return;
  }
    //  Returns Diagnosis instance
    const digested_diagnosis = handleExtractDiagnosis()
    const digested_instructions = digestPrescriptionText()
    
const payload = {
    username: activePatient.patient?.username, // Pass dynamic patient username
    vitals_params: {
      temperature: Number(vitalsValues.temperature) || 0,
      heart_rate: Number(vitalsValues.heart_rate) || 0,
      blood_pressure_systolic: Number(vitalsValues.blood_pressure_systolic) || 0,
      blood_pressure_diastolic: Number(vitalsValues.blood_pressure_diastolic) || 0,
      oxygen: Number(vitalsValues.oxygen) || 0,
    },
    interrogatory: interrogationTextRef.current,
    exploration: explorationTextRef.current,
    diagnosis: digested_diagnosis.diagnosis,
    tags_contained: digested_diagnosis.tags_contained || [],
    lab_order: {
      raw_text: laboratoryTextRef.current,
    },
    prescription: {
      instructions: digested_instructions?.instructions || [],
      raw_text: digested_instructions?.raw_text || prescriptionTextRef.current || "",
    },
  };

  try {
    const response = await submitDiagnosis(payload);
    console.log("Diagnosis entry created successfully:", response);
  } catch (err) {
    console.error("Failed to create diagnosis entry:", err);
  }
  }
  //*/
  //  Function to extract what should be cie tags.
  const extractQuotedWords = (str) => {
    const regex = /"([^"]*)"/gu;
    const matches = [];
    let match;
    while ((match = regex.exec(str)) !== null) {
      matches.push(match[1]);
    }
    return matches;
  };
  //    Function to get ids of matching objects.
  const getMatchingIds = (str, data) => {
    const quotedWords = extractQuotedWords(str);
    return data
      .filter(item => quotedWords.includes(item.name))
      .map(item => item.id_cie);
  };

  const handleExtractDiagnosis = () => {
    if (diagnosisTags.current?.length > 0) {
      return new Diagnosis(diagnosisText.current, getMatchingIds(diagnosisText.current, diagnosisTags.current))
    }
    return new Diagnosis(diagnosisText.current, [])
  };

  //  Check 
  const [vitalsValues, setVitalsValues] = useState({
    temperature: '',
    heart_rate: '',
    blood_pressure_systolic: '',
    blood_pressure_diastolic: '',
    oxygen: '',
  });

  const [vitalsCompleted, setVitalsCompleted] = useState(false);

  const [temperatureBorderColor, setTemperatureBorderColor] = useState('black');
  const [oxygenBorderColor, setOxygenBorderColor] = useState('black');
  const [heartRateBorderColor, setHeartRateBorderColor] = useState('black');
  const [bloodPressureDiastolic, setBloodPressureDiastolic] = useState('black');
  const [bloodPressureSystolic, setBloodPressureSystolic] = useState('black');

  //  Vitals related logic.
  useEffect(() => {
    //  Check if all vitals have values.
    const filled = Object.values(vitalsValues).every(value => value.trim() !== '');
    setVitalsCompleted(filled);

    //  Temperature logic.
    if (vitalsValues.temperature) {
      if (vitalsValues.temperature > 38) {
        //  Fever
        setTemperatureBorderColor(colorVitalSigns.feverColor);
      } else if (vitalsValues.temperature < 35) {
        //  Hyphotermia
        setTemperatureBorderColor(colorVitalSigns.hypothermiaColor);
      } else if (37.8 < vitalsValues.temperature && vitalsValues.temperature < 38) {
        //  Low grade fever
        setTemperatureBorderColor(colorVitalSigns.lowGradeFeverColor);
      }
      else {
        //  Normal parameter
        setTemperatureBorderColor(colorVitalSigns.defaultColor);
      }
    }
    //  Heart rate logic.
    if (vitalsValues.heart_rate) {
      if (vitalsValues.heart_rate > 100) {
        //  Tachycardia.
        setHeartRateBorderColor(colorVitalSigns.tachycardiaColor)
      } else if (vitalsValues.heart_rate < 60) {
        //  Bradycardia.
        setHeartRateBorderColor(colorVitalSigns.bradycardiaColor)
      } else {
        //  Normal parameter
        setHeartRateBorderColor(colorVitalSigns.defaultColor)
      }
    }

    //  Blood pressure systolic.
    if (vitalsValues.blood_pressure_systolic) {
      if (vitalsValues.blood_pressure_systolic < 90) {
        //  Hypotension 
        setBloodPressureSystolic(colorVitalSigns.hypotensionColor)
      } else if (vitalsValues.blood_pressure_systolic > 130) {
        //  Hypertension
        setBloodPressureSystolic(colorVitalSigns.hypertensionColor)
      } else if (vitalsValues.blood_pressure_systolic >= 120 && vitalsValues.blood_pressure_systolic <= 129) {
        //  Pre hypertension
        setBloodPressureSystolic(colorVitalSigns.preHypertensionColor)
      }
      else {
        //  Normal parameter
        setBloodPressureSystolic(colorVitalSigns.defaultColor)
      }
    }
    //  Blood pressure diastolic.
    if (vitalsValues.blood_pressure_diastolic) {
      if (vitalsValues.blood_pressure_diastolic < 60) {
        //  Hypotension 
        setBloodPressureDiastolic('blue')
      } else if (vitalsValues.blood_pressure_diastolic > 80) {
        //  Hypertension
        setBloodPressureDiastolic('red')
      }
      else {
        //  Normal parameter
        setBloodPressureDiastolic('black')
      }
    }
    //  Oxygen saturation logic.
    if (vitalsValues.oxygen) {
      if (vitalsValues.oxygen > 90) {
        //  Normal parameter
        setOxygenBorderColor('black')
      } else {
        //  Low oxygen saturation.
        setOxygenBorderColor('orange')
      }
    }

  }, [vitalsValues]);

  const handleChange = (e) => {
    //  Update vitals values.
    const { name, value } = e.target;
    setVitalsValues({
      ...vitalsValues,
      [name]: value,
    });
  };

  return (
    <Form>
      <Container>
        <Row>
          <Col>
            <Form.Group>
              <Form.Label>{vocab.specialty_note[lan]}</Form.Label>
              <Form.Select aria-label="Default select example">
                <option>{vocab.specialty_note_placeholder[lan]}</option>
                <option value="1">{vocab.gynecology[lan]}</option>
                <option value="2">{vocab.dentistry[lan]}</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col>
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="0">
                <Accordion.Header>{vocab.vitals[lan]} {vitalsCompleted && <span>✔️</span>}</Accordion.Header>
                <Accordion.Body>
                  <Container>
                    <Row>

                      <Col>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                          <Form.Label>{vocab.temperature[lan]}</Form.Label>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                          <Form.Label>{vocab.heart_rate[lan]}</Form.Label>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                          <Form.Label>{vocab.blood_pressure_systolic[lan]}</Form.Label>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                          <Form.Label>{vocab.blood_pressure_diastolic[lan]}</Form.Label>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                          <Form.Label>{vocab.oxygen[lan]}</Form.Label>
                        </Form.Group>
                      </Col>

                    </Row>
                    <Row>
                      <Col>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                          <Form.Control
                            type="number"
                            value={vitalsValues.temperature}
                            name="temperature"
                            onChange={handleChange}
                            placeholder="27.7"
                            style={{ borderColor: temperatureBorderColor }}
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                          <Form.Control
                            type="number"
                            name="heart_rate"
                            value={vitalsValues.heart_rate}
                            onChange={handleChange}
                            placeholder="27.7"
                            style={{ borderColor: heartRateBorderColor }}
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                          <Form.Control
                            type="number"
                            name="blood_pressure_systolic"
                            value={vitalsValues.blood_pressure_systolic}
                            onChange={handleChange}
                            placeholder="27.7"
                            style={{ borderColor: bloodPressureSystolic }}
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                          <Form.Control
                            type="number"
                            name="blood_pressure_diastolic"
                            value={vitalsValues.blood_pressure_diastolic}
                            onChange={handleChange}
                            placeholder="27.7"
                            style={{ borderColor: bloodPressureDiastolic }}
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                          <Form.Control
                            type="number"
                            name="oxygen"
                            min="0"
                            max="100"
                            value={vitalsValues.oxygen}
                            onChange={handleChange}
                            placeholder="90"
                            style={{ borderColor: oxygenBorderColor }}
                          />
                        </Form.Group>
                      </Col>

                    </Row>
                  </Container>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>{vocab.interrogation[lan]} {interrogationCompleted && <span>✔️</span>}</Accordion.Header>
                <Accordion.Body>
                  <Interrogation
                    placeholder={vocab.interrogation_placeholder[lan]}
                    onTextChange={handleTextChangeInterrogation}
                  />
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>{vocab.exploration[lan]} {explorationCompleted && <span>✔️</span>}</Accordion.Header>
                <Accordion.Body>
                  <Exploration
                    placeholder={vocab.exploration_placeholder[lan]}
                    onTextChange={handleTextChangeExploration}
                  />
                </Accordion.Body>
              </Accordion.Item>
              {/*   Diagnosis   */}
              <Accordion.Item eventKey="3">
                <Accordion.Header>{vocab.diagnosis[lan]}</Accordion.Header>
                <Accordion.Body>
                  <div className="d-flex justify-content-end mb-2">
                    <ButtonGroup aria-label="Horizontal button group">
                      <Button
                        variant="outline-secondary"
                        onClick={handleDiagnosisModal}
                        title={btn_vocab.help[lan]} // Tooltip when hovering
                        aria-label="Help button"
                      >
                        <FaQuestionCircle /> {/* Help Icon */}
                      </Button>
                    </ButtonGroup>
                  </div>
                  <DiagnosisTextBox
                    quillRef={quillRef}
                    placeholder={vocab.diagnosis_placeholder[lan]}
                    listBox={(items, activeIndex) => <ListBox2 items={items} activeIndex={activeIndex} onItemClick={handleOptionsClick} />}
                    noItemMessage={() => <div>Sorry, no results found</div>}
                    errorMessage={() => <div>Something went wrong</div>}
                    promise={dataPromiseConditions}
                    onTextChange={handleTextChangeDiagnosis}
                    onTagsChange={handleDiagnosisTags}
                  />
                </Accordion.Body>
              </Accordion.Item>
              {/*   Prescription   */}
              <Accordion.Item eventKey="4">
                <Accordion.Header>{vocab.prescription[lan]}</Accordion.Header>
                <Accordion.Body>
                  {/*   Filter/Help buttons   */}
                  <div className="d-flex justify-content-end mb-2">
                    <ButtonGroup aria-label="Horizontal button group">
                      <Button
                        variant="primary"
                      >
                        Button 1
                      </Button>
                      <Button
                        variant="outline-secondary"
                        onClick={handlePrescriptionModal}
                        title={btn_vocab.help[lan]} // Tooltip when hovering
                        aria-label="Help button"
                      >
                        <FaQuestionCircle /> {/* Help Icon */}
                      </Button>
                    </ButtonGroup>
                  </div>
                  <PrescriptionTextBox
                    placeholder={vocab.prescription_placeholder[lan]}
                    listBox={(items, activeIndex) => <ListBox2 items={items} activeIndex={activeIndex} />}
                    noItemMessage={() => <div>Sorry, no results found</div>}
                    errorMessage={() => <div>Something went wrong</div>}
                    promise={dataPromiseDrugs}
                    onTextChange={handleTextChangePrescription}
                  />
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="5">
                <Accordion.Header>{vocab.laboratory_tests[lan]} {laboratoryCompleted && <span>✔️</span>}</Accordion.Header>
                <Accordion.Body>
                  <LaboratoryTests
                    placeholder={vocab.laboratory_tests_placeholder[lan]}
                    onTextChange={handleTextChangeLaboratory}
                  />
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
        </Row>
        <Row>
          <div className="d-flex justify-content-end">
            <Button variant="primary" size="sm" onClick={handleExtractCompleteEntry} disabled={!enableSaveEntry}>
              {btn_vocab.save[lan]}
            </Button>
          </div>
        </Row>
      </Container>
      <MissingInfoModal
        show={showMissingInfoModal}
        onHide={handleCloseMissingInfoModal}
      />

      <DiagnosisInstructions
        show={showDiagnosisModal}
        onHide={handleCloseDiagnosisModal}
      />
      <PrescriptionInstructions
        show={showPrescriptionModal}
        onHide={handleClosePrescriptionModal}
      />
    </Form>
  );
};

export default DiagnosisForm;
